/**
* Cv.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL Correlation Vector.
*/
var Cv = /** @class */ (function () {
    function Cv(sku) {
        this._sku = sku;
    }
    Cv.prototype.isInit = function () {
        return this._sku.getCvExtension().getCv().isInit();
    };
    Cv.prototype.canExtend = function () {
        return this._sku.getCvExtension().getCv().canExtend();
    };
    Cv.prototype.canIncrement = function () {
        return this._sku.getCvExtension().getCv().canIncrement();
    };
    Cv.prototype.isValid = function (cv) {
        return this._sku.getCvExtension().getCv().isValid(cv);
    };
    Cv.prototype.getValue = function () {
        return this._sku.getCvExtension().getCv().getValue();
    };
    Cv.prototype.setValue = function (cv) {
        this._sku.getCvExtension().getCv().setValueLegacy(cv);
    };
    Cv.prototype.init = function (seedValue) {
        return this._sku.getCvExtension().getCv().initLegacy(seedValue);
    };
    Cv.prototype.extend = function () {
        return this._sku.getCvExtension().getCv().extend();
    };
    Cv.prototype.increment = function () {
        return this._sku.getCvExtension().getCv().increment();
    };
    Cv.prototype.incrementExternal = function (externalCv) {
        return this._sku.getCvExtension().getCv().incrementExternal(externalCv);
    };
    Cv.prototype.useCv1 = function () {
        this._sku.getCvExtension().getCv().useCv1();
    };
    Cv.prototype.useCv2 = function () {
        this._sku.getCvExtension().getCv().useCv2();
    };
    return Cv;
}());
export { Cv };
//# sourceMappingURL=Cv.js.map